export const toSelectOptions = (data) =>
  data?.map((item) => ({
    label: item.description,
    value: item.code,
    longDescription: item.longDescription || null,
  })) || [];

export const toStaticOptions = (values) =>
  values?.map((v) => ({ label: v, value: v })) || [];

export const toCountryOptions = (countries) =>
  countries?.map((country) => ({
    label: country.label,
    value: country.label,
  })) || [];

export default {
  toSelectOptions,
  toStaticOptions,
  toCountryOptions,
};
